module.exports = __webpack_public_path__ + "static/media/explode.31fb26e2.wav";